var React = require('react');

function BoxMinus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.5","y":"1.5","width":"76","height":"76","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M59 37.5417V41.4584H19V37.5417H59Z","fill":"currentColor","key":1})]);
}

BoxMinus.defaultProps = {"width":"79","height":"79","viewBox":"0 0 79 79","fill":"none"};

module.exports = BoxMinus;

BoxMinus.default = BoxMinus;
